import TextTheApp from "../GetApp/TextTheApp";
import { styled } from "@mui/material/styles";
import { motion } from "motion/react";

export const InfluencerSiteWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  maxWidth: 1263,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  paddingBottom: 50,
  [`@media only screen and (max-width: 1600px)`]: {
    maxWidth: "calc(1263px + 10%)", // 1400 max width + 5% padding on each side
    paddingLeft: "5%",
    paddingRight: "5%",
  },
  margin: "0 auto",
  color: theme.vars.palette.text.primary,
  "*": {
    boxSizing: "border-box",
    minWidth: 0,
    verticalAlign: "baseline",
    outline: "none",
  },
  gap: 200,
  [`@media only screen and (max-width: 1280px)`]: {
    gap: 128.7,
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "20px",
    paddingRight: "20px",
    gap: 80,
  },
}));

const SectionWrapper = styled("section")(({ theme }) => ({
  width: "100%",
  scrollSnapAlign: "start",
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const SectionTitle = styled(motion.h3)(({ theme }) => ({
  margin: 0,
  fontSize: 42,
  [theme.breakpoints.down("sm")]: {
    fontSize: 26,
  },
  fontWeight: "bold",
  lineHeight: 1.3,
}));

export const StyledTextTheApp = styled(TextTheApp)(({ theme }) => ({
  marginTop: 6, // gap of 16px + 6px marginTop to equal 22px from the mock
  maxWidth: 433,
  boxSizing: "border-box",
  width: "100%",
  [`@media only screen and (max-width: 1280px)`]: {
    maxWidth: 369,
  },
  [theme.breakpoints.down("md")]: {
    width: 369, // we do this to allow the style in tablet view to be properly applied
    maxWidth: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    marginTop: 22,
    width: "100%",
    maxWidth: 369,
  },
  ".textme_header": {
    fontSize: 16,
    fontWeight: 600,
    color: theme.vars.palette.text.primary,
  },
  ".solid_textlink_to_button": {
    marginTop: 20.9,
    width: 285,
    maxWidth: "100%",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  ".textme_input": {
    display: "flex",
    alignItems: "center",
    border: `1.5px solid ${theme.vars.palette.primary.main}`,
    borderRadius: 100,
    backgroundColor: theme.vars.palette.common.white,
    padding: 9,
    [theme.breakpoints.down("sm")]: {
      padding: 10,
    },
    fontSize: 18,
    "& input": {
      flex: 1,
      margin: "0 10px",
      fontWeight: 500,
      color: theme.vars.palette.text.primary,
      border: 0,
      outline: "none",
      fontSize: 18,
      "&::placeholder": {
        color: "#a7afc4",
      },
    },
    "& .text_button": {
      fontWeight: 500,
      border: 0,
      fontSize: 20,
      backgroundColor: theme.vars.palette.primary.main,
      color: theme.vars.palette.primary.contrastText,
      width: "100%",
      maxWidth: 153,
      borderRadius: 100,
      height: 52,
      padding: 0,
    },
    ".text_prefix": {
      marginLeft: 12, // marginLeft of 21px - 9px of padding,
    },
  },
}));

// ** TEACH SECTION **

export const InfluencerTeachSectionTitle = styled(SectionTitle)(
  ({ theme }) => ({
    marginBottom: 87,
    [theme.breakpoints.down("sm")]: {
      fontSize: 30,
    },
  })
);

export const InfluencerTeachSectionWrapper = styled(SectionWrapper)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [`@media only screen and (max-width: 1280px)`]: {
      marginBottom: 100,
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: 60,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 100,
    },
  })
);

export const InfluencerTeachSectionContentWrapper = styled("div")(
  ({ theme }) => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    position: "relative",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: 200,
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: 120,
    },
  })
);

export const InfluencerTeachTileWrapper = styled("div")(({ theme }) => {
  return {
    zIndex: 1,
    width: "30%",
    maxWidth: "30%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: 350,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: 250,
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    ".img": {
      overflow: "hidden",
      width: 290,
      height: 290,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",

      ".img_bg": {
        width: 250,
        position: "absolute",
        height: 250,
        backgroundColor: "grey",
      },

      ".tophalf": {
        width: 290,
        height: 145,
        position: "relative",
        overflow: "hidden",
      },
      ".bothalf": {
        width: 290,
        height: 145,
        position: "relative",
        overflow: "hidden",
      },

      ".tophalf:after": {
        content: '""',
        position: "absolute",
        top: 20,
        left: 20,
        width: 250,
        height: 250,
        borderRadius: "100%",
        boxShadow: `0px 0px 0px 250px ${theme.vars.palette.common.white}`,
      },

      ".bothalf:after": {
        content: '""',
        position: "absolute",
        top: -125,
        left: 20,
        width: 250,
        height: 250,
        borderRadius: "100%",
        boxShadow: `0px 0px 0px 250px ${theme.vars.palette.common.white}`,
      },
    },
  };
});

export const TeachTileImage = styled(motion.img)(({ theme }) => ({
  height: "100%",
  objectFit: "contain",
  position: "absolute",
}));

export const InfluencerTeachTileTitle = styled(motion.h4)(({ theme }) => ({
  fontSize: 24,
  margin: 0, // reset the browser default for h tags
  marginTop: 35,
  fontWeight: "bold",
  lineHeight: 2.75,
  textAlign: "center",
}));

export const InfluencerTeachTileDescription = styled("p")(({ theme }) => ({
  textAlign: "center",
  lineHeight: 1.6,
  fontSize: 20,
  fontWeight: 500,
  margin: 0,
  width: 300,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    maxWidth: 375,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 16,
  },
}));

// ** HEAD **

export const InfluencerHeadWrapper = styled(SectionWrapper)(({ theme }) => ({
  display: "flex",
  flex: 1,
  justifyContent: "center",
  paddingTop: 100,
  gap: "12%",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: 60,
    maxWidth: 420,
    margin: "0 auto",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: 80,
  },
}));

export const InfluencerHeadTextWrapper = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  maxWidth: 520,
  gap: 16,
  [`@media only screen and (max-width: 1280px)`]: {
    gap: 10,
    maxWidth: 432,
  },
  [theme.breakpoints.down("md")]: {
    alignItems: "center",
    textAlign: "center",
  },
}));

export const InfluencerTitle = styled("h1")(({ theme }) => ({
  fontWeight: "bold",
  fontSize: 64,
  lineHeight: 1.25,
  margin: 0,
  [`@media only screen and (max-width: 1280px)`]: {
    fontSize: 60,
    lineHeight: 1.2,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 40,
    lineHeight: 1.25,
  },
}));

export const InfluencerSubtitle = styled("h2")(({ theme }) => ({
  fontSize: 20,
  lineHeight: 1.6,
  margin: 0,
  fontWeight: 500,
  maxWidth: 361,
  [`@media only screen and (max-width: 1280px)`]: {
    maxWidth: 416,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 16,
  },
}));

export const InfluencerHeaderVideoWrapper = styled("div")(({ theme }) => ({
  borderRadius: 16,
  display: "flex",
  height: "100%",
  ".hexagon_logo": {
    marginLeft: "-80px",
    marginTop: "108px",
    marginBottom: "auto",
    height: "auto",
    width: 240,
    [`@media only screen and (max-width: 1280px)`]: {
      marginTop: "70px",
      width: 180,
      marginLeft: "-60px",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  ".brandclub_video": {
    width: 432, // use width instead of max-width to avoid having the video container shrink when the video plays
    aspectRatio: "initial", // prevents cropping of the video
    [`@media only screen and (max-width: 1280px)`]: {
      width: 375,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: 381,
    },
    borderRadius: 16,
    ".video_content": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
}));

// ** DETAIL SECTION **

export const InfluencerDetailSectionWrapper = styled(SectionWrapper)(
  ({ theme }) => ({
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    maxWidth: 1174,
    "&.influencer1": {
      marginTop: 50,
    },
    marginLeft: "auto",
    marginRight: "auto",

    [`@media only screen and (max-width: 1280px)`]: {
      gap: 50,
      margin: "0px auto",
    },
    [theme.breakpoints.down("md")]: {
      gap: 40,
      flexDirection: "column-reverse",
    },
  })
);

export const InfluencerDetailReverseSectionWrapper = styled(
  InfluencerDetailSectionWrapper
)(({ theme }) => ({
  flexDirection: "row-reverse",
}));

export const InfluencerDetailSectionTitle = styled(SectionTitle)(
  ({ theme }) => ({
    marginBottom: 12,
  })
);

export const InfluencerDetailSectionDescription = styled("p")(({ theme }) => ({
  margin: 0,
  fontSize: 20,
  fontWeight: 500,
  lineHeight: 1.6,
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    fontSize: 16,
    lineHeight: 1.5,
  },
}));

export const InfluencerDetailSectionTextWrapper = styled(motion.div)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    [`@media only screen and (max-width: 1280px)`]: {
      marginTop: 40,
    },
    maxWidth: 440,
  })
);

export const InfluencerDetailSectionImage = styled(motion.img)(() => ({
  height: "100%",
  objectFit: "contain",
}));

export const InfluencerDetailSectionImageWrapper = styled(motion.div)(() => ({
  position: "relative",
  width: 548,
  maxWidth: "100%",
  aspectRatio: "548/626",
  display: "flex",
  alignItems: "center",
  [`@media only screen and (max-width: 1280px)`]: {
    width: 459,
  },
}));

// ** SHARE SECTION **

export const InfluencerShareSectionImage = styled(motion.img)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  width: "100%",
  maxWidth: 648,
  minWidth: 525,
  [`@media only screen and (max-width: 1280px)`]: {
    maxWidth: 525,
    minWidth: 476,
  },
  [theme.breakpoints.down("md")]: {
    maxWidth: 476,
    minWidth: 0,
  },
}));

export const InfluencerQuoteWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  maxWidth: 532,
  span: {
    marginTop: 24,
    fontSize: 24,
    display: "block",
  },
  ".img-quote": {
    width: "auto",
    height: 34.2,
    marginBottom: 36,
  },
}));

export const InfluencerShareSectionQuote = styled("blockquote")(
  ({ theme }) => ({
    margin: 0,
    fontSize: 42,
    fontWeight: "bold",
    lineHeight: 1.3,
    [`@media only screen and (max-width: 1280px)`]: {
      fontSize: 30,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 22,
      lineHeight: 1.45,
      textAlign: "center",
    },
  })
);

export const InfluencerShareSectionWrapper = styled(SectionWrapper)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 60,
    [`@media only screen and (max-width: 1280px)`]: {
      gap: 40,
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: 80,
      marginTop: 0,
    },
    [theme.breakpoints.down("sm")]: {
      gap: 50,
      marginBottom: 100,
    },
  })
);

// ** GET APP SECTION **

export const InfluencerGetAppSectionTitle = styled(SectionTitle)(
  ({ theme }) => ({
    fontWeight: "bold",
    fontSize: 70,
    lineHeight: 1.14,
    maxWidth: 443,
    [`@media only screen and (max-width: 1280px)`]: {
      fontSize: 50,
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 76,
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 234,
      fontSize: 40,
      lineHeight: 1.18,
    },
  })
);

export const InfluencerGetAppSectionImage = styled(motion.img)(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  width: "100%",
  maxWidth: 699,
  [`@media only screen and (max-width: 1280px)`]: {
    maxWidth: 500,
  },
  [theme.breakpoints.down("sm")]: {
    maxWidth: 300,
  },
}));

export const InfluencerGetAppSignContentWrapper = styled("div")(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      textAlign: "center",
    },
  })
);

export const InfluencerGetAppSectionWrapper = styled(SectionWrapper)(
  ({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    gap: 50,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  })
);
